// Matches custom (non-collection) menu links to a merchant-configured image by
// exact title text, and injects it. Needed because Shopify only resolves a
// `_menu-link-image` block's settings once it's actually rendered as hidden
// JSON data (see blocks/_menu-link-image.liquid) — the parent menu can't read
// nested block settings directly.
//
// Runs a few times shortly after load (in addition to on DOM mutations) because
// something in the menu markup does a one-time re-render right after initial
// paint that wipes an image inserted before it settles, and that swap doesn't
// surface as an observable body mutation.
(function () {
  function apply() {
    var dataEls = document.querySelectorAll('script.menu-link-image-data');
    if (!dataEls.length) return;

    var imagesByTitle = {};
    dataEls.forEach(function (el) {
      try {
        var data = JSON.parse(el.textContent);
        if (data.title && data.image) {
          imagesByTitle[data.title.trim().toLowerCase()] = data.image;
        }
      } catch (error) {
        // Ignore malformed entries.
      }
    });

    if (Object.keys(imagesByTitle).length === 0) return;

    var links = document.querySelectorAll('a.mega-menu__link, a.menu-drawer__menu-item--child');
    links.forEach(function (link) {
      if (link.querySelector('img')) return;

      var title = link.textContent.trim().toLowerCase();
      var imageUrl = imagesByTitle[title];
      if (!imageUrl) return;

      var img = document.createElement('img');
      img.src = imageUrl;
      img.loading = 'lazy';
      img.alt = '';
      img.className = link.classList.contains('mega-menu__link')
        ? 'mega-menu__link-image'
        : 'menu-drawer__link-image';
      link.insertBefore(img, link.firstChild);
    });
  }

  var applyScheduled = false;
  function scheduleApply() {
    if (applyScheduled) return;
    applyScheduled = true;
    requestAnimationFrame(function () {
      applyScheduled = false;
      apply();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  // Catch the post-load re-render that isn't visible to the MutationObserver below.
  [50, 150, 350, 750, 1500].forEach(function (delay) {
    setTimeout(apply, delay);
  });

  new MutationObserver(scheduleApply).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
